module.exports = __webpack_public_path__ + "assets/80f3e02a16fed60262cca7b6083cd11f.mp3";